module.exports = __webpack_public_path__ + "media/images/slider_h1_sp_04-331194252fd5fc7f872186ec048320b2.png";